import { getDateTimeFormatter } from '@fe/core';
import { GDFDelayElement, GDFDelayRecord } from '../../../gdf/type';

export default function FaaDelayTooltip({ record }: { record: GDFDelayRecord }) {
    return (
        <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'max-content max-content', columnGap: '0.5rem' }}>
                <div>Station:</div>
                <div>{record.airportId}</div>
            </div>

            <div>
                {record.elements.length === 0 && <span>No delays</span>}
                {record.elements.length > 0 && record.elements.map((element, i) => <FaaDelayElement element={element} key={i} />)}
            </div>
        </div>
    );
}

function FaaDelayElement({ element }: { element: GDFDelayElement }) {
    const formatter = getDateTimeFormatter();
    let type = '';
    switch (element.type) {
        case 'C':
            type = element.trend == 0 ? 'Closure' : 'Partial closure';
            break;
        case 'P':
            type = 'Ground Stop';
            break;
        case 'G':
            type = 'Ground Delay';
            break;
        case 'A':
            type = 'Arrival Delay';
            break;
        case 'D':
            type = 'Departure Delay';
            break;
    }

    return (
        <div className="pt-1">
            <div>
                <span>{type}</span>
                <span> </span>
                {(element.type === 'C' || element.type == 'P') && (
                    <span>
                        Start: {formatter.formatTime(element.startTime, 'hm')} {type === 'C' ? 'Reopen' : 'End'}:{' '}
                        {formatter.formatTime(element.stopTime, 'hm')}
                    </span>
                )}
                {element.type === 'G' && <span>Avg {element.delayMinutesMinAvg} min</span>}
                {(element.type === 'A' || element.type === 'D') && (
                    <span>
                        <span>Min: {element.delayMinutesMinAvg} min </span>
                        <span>Max: {element.delayMinutesMax} min </span>
                        {/* 73 = 'I', 68 = 'D' */}
                        {(element.trend === 73 || element.trend === 68) && (
                            <span>Trend: {element.trend === 73 ? 'Increasing' : 'Decreasing'}</span>
                        )}
                    </span>
                )}
            </div>
            {element.reason.length > 0 && <div>Reason: {element.reason}</div>}
        </div>
    );
}
